import { render, staticRenderFns } from "./ListFundWalletsPage.vue?vue&type=template&id=347d0e0a&scoped=true"
import script from "./ListFundWalletsPage.vue?vue&type=script&lang=js"
export * from "./ListFundWalletsPage.vue?vue&type=script&lang=js"
import style0 from "./ListFundWalletsPage.vue?vue&type=style&index=0&id=347d0e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d0e0a",
  null
  
)

export default component.exports